<template>
  <div class="form-group" v-bind:class="{ 'has-error': error }">
    <label v-if="label" :for="name">{{ label }}</label>
    <input type="text"
           class="form-control"
           :name="name"
           :required="required"
           :disabled="disabled"
           :placeholder="placeholder"
           :value="value | phone"
           v-mask="'(99)9999-9999[9]'"
           v-on:keyup="updateValue($event.target.value)"
           v-on:blur="updateValue($event.target.value)"
    >
    <span v-if="error"
          class="help-block"
          v-html="error"
    ></span>
  </div>
</template>

<script>
  export default{
    name: 'InputPhone',
    props: ['name', 'value', 'required', 'label', 'placeholder', 'error', 'disabled'],
    methods: {
      updateValue (value) {
        this.$emit('input', this.phoneNumber(value))
      }
    }
  }
</script>


// WEBPACK FOOTER //
// InputPhone.vue?0585a706